import { programLabels } from "@/config";
import { Button, Card, Col, Form, Row, Upload } from "antd";
import { post } from "@/libs/axios";
import { UploadOutlined } from "@ant-design/icons";
import useGlobalConfig from "@/store/global";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Loader } from "lucide-react";

// eslint-disable-next-line react/prop-types
const FormContent = ({ isReceived, programName, loading }) => {
  const { themeColor } = useGlobalConfig()
  const [submitLoading, setSubmitLoading] = useState(false)
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setSubmitLoading(true)

    const formData = new FormData();

    Object.keys(values).forEach(key => {
      formData.append(key, values[key].file)
    })

    try {
      await post('patient_assistance_requests', formData);
      navigate("/")
    } catch (e) {
      console.log(e)
    } finally {
      setSubmitLoading(false)
    }
  }

  return (
    <div className="pb-10">
      <div className="text-xl md:text-3xl font-bold">
        {programLabels[programName].label} Program
      </div>

      { loading && <Loader className="mt-10 animate-spin" /> }

      { isReceived ? (
        <div className="mt-10">
          <p className="py-2 px-4 bg-green-100 text-green-600 rounded">
            Your application has been received. We will be in touch
            shortly. Thank you.
          </p>
        </div>
      ) : (
        <Card className="mt-10 text-base">
          <div className="my-2 font-bold">FINANCIAL HARDSHIP GUIDELINE</div>
          <div className="my-2">
            Before applying for the GAMMAKED Copay Assistance Program please ensure your gross annual income is no more
            than 250% of the&nbsp;
            <a target="_blank" href="https://aspe.hhs.gov/2020-poverty-guidelines"
               className="text-blue-500 hover:underline">
              federal poverty level as defined by the Department of Health and Human Services.
            </a>
          </div>

          <Form form={form} onFinish={onFinish}>
            <div className="mt-10 font-bold">STEP 1: APPLY FOR FINANCIAL ASSISTANCE FOR {programName.toUpperCase()}</div>
            <div className="my-2">
              Please download the&nbsp;
              <a target="_blank" href="/Kedrab_PAP_application_form.pdf"
                 className="text-blue-500 hover:underline">
                program application by clicking here.
              </a>
            </div>

            <p className="my-2">Once your application has been completed by you and your healthcare provider, please</p>

            <Row className="mt-4">
              <Col span={24}>
                <Form.Item
                  name="program_application_file"
                  label="Upload the program application"
                  rules={[{ required: true }]}>

                  <Upload
                    listType="text"
                    beforeUpload={() => {
                      return false
                    }}
                  >
                    <Button
                      className="mr-2 rounded bg-[#5bc0de] text-white"
                      icon={<UploadOutlined />}
                    >
                      Upload
                    </Button>
                  </Upload>
                </Form.Item>
              </Col>
            </Row>

            <p>Alternatively, the completed application can be faxed to us at (408) 419-1768</p>


            <div className="mt-10 font-bold">STEP 2: INCOME VERIFICATION</div>
            <p className="my-2">After you have completed step 1 above, please either upload or fax a copy of one (1) of
              the following documents.</p>
            <p className="mt-4">1) Last year’s federal income tax return OR
            </p>
            <p className="my-2">2) Social Security Yearly Benefits Statement (SSA-1099) OR</p>
            <p className="my-2">3) All income statements from jobs held in the last year.</p>
            <Row className="mt-4">
              <Col span={24}>
                <Form.Item
                  name="income_verification_file"
                  label="Please upload one of the above mentioned documents"
                  rules={[{ required: true }]}>

                  <Upload
                    listType="text"
                    beforeUpload={() => {
                      return false
                    }}
                  >
                    <Button
                      className="mr-2 rounded bg-[#5bc0de] text-white"
                      icon={<UploadOutlined />}
                    >
                      Upload
                    </Button>
                  </Upload>
                </Form.Item>
              </Col>
            </Row>
            <p className="my-2">Alternatively, the document can be faxed to us at (408) 419-1768</p>

            <p className="mt-10">
              For further questions or inquiries, please visit&nbsp;
              <a target="_blank" href="https://kedrab.com/"
                 className="text-blue-500 hover:underline">
                www.kedrab.com/
              </a>
              &nbsp;or call 1-(866) ADHERE-2 (501-8040) Monday through Friday, 9 AM to 8 PM Eastern Time.
            </p>

            {
              !isReceived && (
                <Row className="my-10">
                  <Col span={8} offset={8}>
                    <Button
                      loading={submitLoading}
                      disabled={submitLoading}
                      type="primary"
                      htmlType="submit"
                      style={{
                        width: "100%",
                        backgroundColor: themeColor,
                        height: "40px",
                        fontSize: "18px",
                      }}>Submit</Button>
                  </Col>
                </Row>
              )
            }

          </Form>
        </Card>
        )}
    </div>
  )
}

export default FormContent